const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

let isRefreshing = false;
let queue = [];
const cache = new Map();
const inFlight = new Map();

// Listeners para sincronização de token
const tokenListeners = new Set();

export function onTokenChange(callback) {
  tokenListeners.add(callback);
  return () => tokenListeners.delete(callback);
}

function notifyTokenChange(token) {
  tokenListeners.forEach(cb => {
    try {
      cb(token);
    } catch (err) {
      // silently handle listener errors
    }
  });
}

async function refreshToken() {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) {
    throw new Error("No refresh token");
  }

  try {
    const resp = await fetch(`${API_BASE}/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    if (!resp.ok) {
      throw new Error(`Refresh failed: ${resp.status}`);
    }

    const data = await resp.json();

    localStorage.setItem("token", data.token);
    notifyTokenChange(data.token);

    return data.token;
  } catch (err) {
    throw err;
  }
}

export async function apiFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  const isFormData = options.body instanceof FormData;

  const doRequest = async (tkn) => {
    const reqHeaders = {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(options.headers || {}),
      Authorization: `Bearer ${tkn}`,
    };

    return fetch(`${API_BASE}${url}`, {
      ...options,
      signal: options.signal,
      headers: reqHeaders,
    });
  };

  let response = await doRequest(token);

  if (response.status !== 401) {
    return response;
  }

  // 🚨 se request foi cancelado, não faz refresh
  if (options.signal?.aborted) {
    throw new DOMException("Aborted", "AbortError");
  }

  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      queue.push({ resolve, reject });
    }).then((newToken) => {
      // 🚨 proteção contra abort após refresh
      if (options.signal?.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }
      return doRequest(newToken);
    });
  }

  isRefreshing = true;

  try {
    const newToken = await refreshToken();

    queue.forEach((p) => p.resolve(newToken));
    queue = [];

    // 🚨 proteção também no fluxo principal
    if (options.signal?.aborted) {
      throw new DOMException("Aborted", "AbortError");
    }

    return await doRequest(newToken);
  } catch (err) {
    queue.forEach((p) => p.reject(err));
    queue = [];

    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    notifyTokenChange(null);

    window.location.href = "/login";

    throw err;
  } finally {
    isRefreshing = false;
  }
}